// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Atom_Cta from "../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../atom/Atom_Row.bs.js";
import * as Util_Css from "../../util/Util_Css.bs.js";
import * as Atom_Cell from "../atom/Atom_Cell.bs.js";
import * as Atom_Logo from "../atom/Atom_Logo.bs.js";
import * as Atom_Text from "../atom/Atom_Text.bs.js";
import * as Atom_Image from "../atom/Atom_Image.bs.js";
import * as Atom_Column from "../atom/Atom_Column.bs.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Atom_Text_Ds from "../atom/Atom_Text_Ds.bs.js";
import * as Particle_zIndex from "../particle/Particle_zIndex.bs.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../particle/Particle_Spacer_Ds.bs.js";
import * as Particle_Animation_Ds from "../particle/Particle_Animation_Ds.bs.js";
import * as Particle_Screen_Constants from "../particle/Particle_Screen_Constants.bs.js";

var rules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Util_Css.preserveAspectRatioRules("R16_9"));

var rules$1 = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.position("absolute")]);

var $$Image = {
  rules: rules$1
};

var rules$2 = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
      CssJs.position("absolute"),
      Particle_zIndex.Particle_zIndex_Css.toCss({
            TAG: /* Exact */0,
            _0: /* TopTeaser */19
          })
    ]);

var Content = {
  rules: rules$2
};

var Molecule_TopTeaser_Presse_Css = {
  rules: rules,
  $$Image: $$Image,
  Content: Content
};

function Molecule_TopTeaser_Presse(Props) {
  var title = Props.title;
  var subtitle = Props.subtitle;
  var description = Props.description;
  var href = Props.href;
  var imageAlt = Props.imageAlt;
  var imageSrc = Props.imageSrc;
  var ref_ = Props.ref_;
  var tmp = {
    blockSpace: Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeAll("XL")), undefined, undefined, Particle_Spacer_Ds.makeAll("S")),
    children: null,
    height: Particle_Screen_Constants.oneHundredPctHeight,
    rules: rules$2,
    width: Particle_Screen_Constants.oneHundredPctWidth
  };
  if (ref_ !== undefined) {
    tmp.ref_ = Caml_option.valFromOption(ref_);
  }
  return React.createElement(Atom_Cta.Link.Block.make, {
              children: React.createElement(Atom_Column.make, {
                    children: null,
                    height: Particle_Screen_Constants.oneHundredPctHeight,
                    rules: rules,
                    width: Particle_Screen_Constants.oneHundredPctWidth
                  }, React.createElement(Atom_Cell.make, {
                        width: Particle_Screen_Constants.oneHundredPctWidth,
                        height: Particle_Screen_Constants.oneHundredPctHeight,
                        children: React.createElement(Atom_Image.Presse.make, {
                              alt: imageAlt,
                              animation: Particle_Animation_Ds.TopTeaserPresse.background,
                              autoSize: Particle_Screen_Constants.autoSizeAllPlaceAvailable,
                              kind: /* Gradient */1,
                              src: imageSrc,
                              style: /* PresseTopTeaser */12
                            }),
                        rules: rules$1
                      }), React.createElement(Atom_Row.make, tmp, React.createElement(Atom_Cell.make, {
                            alignItems: Particle_Screen_Constants.alignItemsCenter,
                            children: React.createElement(Atom_Logo.make, {
                                  logo: {
                                    NAME: "ArteVerticalLogo",
                                    VAL: "MenuNavigation"
                                  }
                                })
                          }), React.createElement(Atom_Column.make, {
                            autoSize: Particle_Screen_Constants.autoSizeAllPlaceAvailable,
                            children: null,
                            justifyContent: Particle_Screen_Constants.justifyContentSpaceBetween
                          }, React.createElement(Atom_Cell.make, {
                                children: React.createElement(Atom_Text.make, {
                                      children: subtitle,
                                      style: Atom_Text_Ds.makeTopTeaserPresse("Subtitle")
                                    }),
                                animation: Particle_Animation_Ds.TopTeaserPresse.subtitles
                              }), React.createElement(Atom_Cell.make, {
                                children: React.createElement(Atom_Text.make, {
                                      children: title,
                                      style: Atom_Text_Ds.makeTopTeaserPresse("Title")
                                    }),
                                animation: Particle_Animation_Ds.TopTeaserPresse.title
                              }), React.createElement(Atom_Cell.make, {
                                children: React.createElement(Atom_Text.make, {
                                      children: description,
                                      style: Atom_Text_Ds.makeTopTeaserPresse("Desc")
                                    }),
                                animation: Particle_Animation_Ds.TopTeaserPresse.subtitles
                              })))),
              href: href,
              style: {
                TAG: /* Presse */16,
                _0: /* TopTeaser */4
              }
            });
}

Molecule_TopTeaser_Presse.displayName = "TopTeaserPresse";

var make = Molecule_TopTeaser_Presse;

export {
  Molecule_TopTeaser_Presse_Css ,
  make ,
}
/* rules Not a pure module */
